// split-test: resource_show_modal_view

import './modal-view.css';
